import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    clienteId: 0,
    clienteNombre: '',

    /* Registro de acciones */
    contactos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    nombre: '',
    incluirInactivos: false,

    /* Listas de selección */
    contactosList: [],
    contactosSelectList: [],

    rpt: []
};

const mutations = {
    updateField,

    'INICIALIZAR_CONTACTOS'(state, clienteId) {
        state.clienteId = clienteId;
        state.clienteNombre = '';
        
        state.contactos = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'SET_CLIENTE'(state, clienteNombre) {
        state.clienteNombre = clienteNombre;
    },
    'SET_CONTACTOS'(state, contactos) {
        state.contactos = contactos;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state, clienteId) {
        state.clienteId = clienteId;
        state.contactosList = [];
        state.contactosSelectList = [];
    },
    'SET_LIST'(state, params) {
        state.contactosList = params.contactosList;
        state.contactosSelectList = params.contactosSelectList;
    },

    'INICIALIZAR_RPT'(state, clienteId) {
        state.rpt = [];
    },
    'SET_RPT'(state, rpt) {
        state.rpt = rpt;
    },
};

const actions = {
    inicializar: ({ commit }, clienteId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONTACTOS', clienteId);

            apiAxios.get('clientes/' + clienteId)
                .then(res => {
                    commit('SET_CLIENTE', res.data.nombreComercial);

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
    getClientesContactos: ( {commit} ) => {
        return new Promise((resolve, reject) => {
            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&clienteId=' + state.clienteId;

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }

            if ((/true/i).test(state.incluirInactivos)) {
                queryString += '&incluirInactivos=true';
            }

            apiAxios.get('clientescontactos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_CONTACTOS', res.data);

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },

    getClientesContactosList: ({commit}, clienteId) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST', clienteId);
            apiAxios.get('clientescontactos/' + clienteId + '/list')
                .then(res => {
                    var list = []
                    for(let key in res.data) {
                        const item = res.data[key]
                        list.push(item.nombre.trim())
                    } 
                    var params = {
                        contactosList: res.data,
                        contactosSelectList: list
                    };
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
    getRptClientesContactos: ( {commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            let queryString = '';

            if (params.clienteId != 0) {
                queryString = '?clienteId=' + params.clienteId;
            }
            
            if (params.incluirInactivos) {
                if (queryString == '') {
                    queryString = '?incluirInactivos=true';
                } else {
                    queryString += '&incluirInactivos=true';
                }
            }

            apiAxios.get('clientescontactos/list' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },    
};

const getters = {
    getField,

    contactos (state) {
        return state.contactos;
    },
    contactosList (state) {
        return state.contactosList;
    },
    contactosSelectList (state) {
        return state.contactosSelectList;
    },
    rpt (state) {
        return state.rpt;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}